import type {
  AppearancePreference,
  AppearancePreset,
} from '../ports/appearancePreference';

export const APPEARANCE_STORAGE_KEY = 'cpq:appearance:v1';

export const browserAppearancePreference: AppearancePreference = {
  read(): AppearancePreset {
    try {
      const preset = window.localStorage.getItem(APPEARANCE_STORAGE_KEY);
      switch (preset) {
        case 'minimal':
        case 'purple':
        case 'warm-gold':
        case 'classic-desktop':
        case 'pearl-glass':
          return preset;
        default:
          return 'minimal';
      }
    } catch {
      return 'minimal';
    }
  },
  write(preset) {
    try {
      window.localStorage.setItem(APPEARANCE_STORAGE_KEY, preset);
      return true;
    } catch {
      return false;
    }
  },
};
